
<template>
  <card>
    <h4 slot="header" class="card-title">Geri Bildirimler
    </h4>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption >Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th>ID</th>
        <th>E-Posta</th>
        <th>Mesaj</th>
        <th>Tarih</th>
        <th></th>

      </thead>
      <tbody>
        <tr v-if="item" v-for="item in table" :key="item.id">
          <td>{{item.url}}</td>
          <td>{{item.name}}</td>
          <td style="width:45%">{{item.content.content}}</td>
          <td>{{item.created | duration('add', 3, 'hours') | moment('add', '3 hours', "DD.MM.YYYY HH:mm:ss")}}</td>
          <td><button class="btn btn-sm btn-danger" v-on:click="deactivate(item.id)">Sil</button></td>
          
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-bind:class="{active: isActive(current)}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>


  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        post:{
          status:0
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id){
        this.toggleLoader()
        this.post.status = 0
        this.$http.post('/api/posts/edit/' + id, this.post).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Geri bildirim silindi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'all') {
        this.toggleLoader()
        this.type = t
        var url = '/api/filter/posts/post-type/feedback/status/1/limit/' + this.limit + '/page/' + p
        
        this.$http
        .get(url)
        .then(
          response => {
            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
            this.toggleLoader()
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            this.toggleLoader()
          }
          )
      }
    },
    mounted: function () {
      this.$nextTick(function () {

        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FeedbackModules/Index.vue